import Badge, { type BadgeTone } from './Badge'

/**
 * Paylaşılan durum rozeti (013 tasarım dili — FR-008 tek kaynak). Durum id → ton eşlemesi **yalnız
 * burada**; `Badge` (soft varyantı) ile Figma görünümünde (renkli dolgulu pill) render edilir.
 *
 * REFERANS TICKET_REQUEST_STATUS: 300 Beklemede (mavi) / 301 Onaylandı (yeşil) / 302 Reddedildi (kırmızı).
 * REFERANS ACTIVITY_STATUS (024): 350 Bekliyor (mavi) / 351 Katılıyor (yeşil) / 352 Katılmıyor (kırmızı).
 */
export interface StatusTagProps {
  statusId?: number
  label?: string
}

const TONE: Record<number, BadgeTone> = {
  300: 'blue',
  301: 'green',
  302: 'red',
  350: 'blue',
  351: 'green',
  352: 'red',
}

export default function StatusTag({ statusId, label }: Readonly<StatusTagProps>) {
  const tone = (statusId != null && TONE[statusId]) || 'blue'
  return (
    <Badge tone={tone} variant="soft">
      {label}
    </Badge>
  )
}
